<!-- @format -->

@if (cart && showAutoConfirmWizard !== undefined) {
  <app-cart-wizard-container [wizardStepKeys]="wizardStepNames" [currentStep]="currentStep" *transloco="let t">
    <!-- Unlike in other wizard steps, do NOT autofocus the heading, because we just returned from an external payment system,
    and thus the screen reader should tell the user where they are. -->
    <app-cart-wizard-step-heading [wizardStepKeys]="wizardStepNames" [currentWizardStepIndex]="currentStep" />
    <div class="row">
      <div class="col-md-10 col-sm-12">
        <div class="thank-you-texts">
          @if (!showAutoConfirmWizard || cart.state !== "ACTIVATED") {
            <transloco
              data-cy="thank-you-text"
              key="OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.THANK_YOU_TEXT"
              [params]="{ orderNumber: cart.orderNumber, buyerEmail: cart.buyerEmail }"></transloco>
          }
          @if (showAutoConfirmWizard && cart.state === "ACTIVATED") {
            <transloco
              data-cy="thank-you-text"
              key="OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.THANK_YOU_TEXT_AUTO_CONFIRM"
              [params]="{ orderNumber: cart.orderNumber, buyerEmail: cart.buyerEmail }"></transloco>
          }
        </div>
        @if (cart.state !== "ACTIVATED" && showAutoConfirmWizard) {
          <sis-contextual-notification variant="warning" data-cy="auto-confirmation-failed">
            <div>
              <transloco
                key="OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.AUTO_CONFIRMATION_FAILED"
                [params]="{ orderNumber: cart?.orderNumber }"></transloco>
              @if (contactInfo$ | async; as contactInfo) {
                @if (contactInfo.isEmail) {
                  <a [href]="'mailto:' + contactInfo.link"> {{ contactInfo.link }}.</a>
                } @else {
                  @if (contactInfo.contactLinkText) {
                    <a [href]="contactInfo.link"> {{ contactInfo.contactLinkText }}.</a>
                  }
                }
              }
            </div>
          </sis-contextual-notification>
        }
        @if (!showAutoConfirmWizard) {
          <div class="confirm-enrolments">
            <fudis-heading [level]="3">
              {{ "OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.CONFIRM_ENROLMENT_TITLE" | translate }}
            </fudis-heading>
            <div class="row">
              <div class="col-xl-8">
                <p>{{ "OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.CONFIRM_TEXT_1" | translate }}</p>
                <p data-cy="confirm-text-2">{{
                  "OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.CONFIRM_TEXT_2" | translate: { buyerEmail: cart.buyerEmail }
                }}</p>
                <p>{{ "OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.CONFIRM_TEXT_3" | translate }}</p>
              </div>
              <div class="confirm-button-div col-xl-4">
                <sis-button
                  type="button"
                  variant="primary"
                  (clicked)="redirectToStudiesActivateWizard()"
                  data-cy="confirm-enrolment-button">
                  {{ "OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.CONFIRM_ENROLMENT_BUTTON" | translate }}
                </sis-button>
              </div>
            </div>
            <div class="row guidance-div">
              <div class="notification-icon"><sis-icon [icon]="'notification'" [color]="'primary'"></sis-icon></div>
              <div class="guidance-text">
                <transloco
                  class="guidance"
                  key="OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.GUIDANCE"
                  [params]="{ activationCode: cart.activationCode }"
                  data-cy="activation-code-guidance">
                </transloco>
              </div>
            </div>
          </div>
        }
        <fudis-heading [level]="3">
          {{ "OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.COURSE_UNIT_TITLE" | translate }}
        </fudis-heading>
        <app-cart-accordions [cart]="cart" [isEditable]="false" [hideEnrolmentQuestonnaire]="!showAutoConfirmWizard"></app-cart-accordions>
        <div class="row price">
          <div class="col-sm-7"></div>
          <div class="row col-sm-5">
            <app-cart-price [cart]="cart" [showOnlySummary]="true" [alignRight]="true"></app-cart-price>
          </div>
        </div>
      </div>
      @if (showAutoConfirmWizard) {
        <div class="col-12 col-lg-10">
          <sis-wizard-step-buttons
            [forwardButtonTitle]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.MONETARY_PAYMENT.CLOSE' | translate"
            [backButtonDisplay]="false"
            (forward)="goToFrontPage()" />
        </div>
      }
    </div>
  </app-cart-wizard-container>
}
